import React from "react";
import { Carousel } from 'react-bootstrap';
import 'aos/dist/aos.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../css/Project.css'
import '../css/Common-style.css'

import {Project_data} from "./Project_data.js"

class Projects extends React.Component {
render() {
return (
        <section id="Projects">
        <div className='container-fluid project-container'>
        <div className="row">
        <div className="col-sm-12">
        <h1 data-aos="fade-right" className="title text-center">PROJECTS</h1>
        </div>
        </div>
        <div data-aos="fade-left" data-aos-duration="1000" className="row slider-container">
        <div className="col-12">
        <Carousel>
            {Project_data.map((project)=>{
                return(
                    <Carousel.Item>
                        <div key={project.id} className="project-content grid swiper-slide">
                            <div className="project-image-container">
                                <img src={project.image} className="img-fluid project-image" alt={project.alt}/>
                            </div>
                        
                            <div className="project-data">
                                <h3 className="project-title">{project.title}</h3>
                                <p className="project-description">{project.description}</p>
                                <div className="btn-container">
                                    <a href={project.url} target="_blank" rel="noreferrer" className="project-button btn">
                                        {project.btn_title}
                                        <i class="far fa-arrow-right button-icon"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </Carousel.Item>
                );
            })}
        </Carousel>
        </div>
        </div>
        </div>
        </section>
        )
        };
        }
export default Projects;
